import type { FaireProductEntity } from "../../entity_types/product";

export const p_ww5z7d42s9: FaireProductEntity = {
  token: "p_ww5z7d42s9",
  type: "product",
  name: "Duck Family with Mother and Three Babies, Set of 4",
  brandName: "Evergreen Enterprises",
  imageUrl:
    "https://cdn.faire.com/fastly/33a3cb7822770ecd5a7cce4b017eb5e8ce3416e8eaab839d0958d7b6aa0307dd.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2bf4f8009484c0b452abb66d6fdd58622bc6e55fdf5e3e722f10892284731349.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
